import {PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading} from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {provideMissingTranslationHandler, provideTranslateLoader, provideTranslateService, TranslateService} from "@ngx-translate/core";
import {provideHttpClient, withInterceptors, withXhr} from "@angular/common/http";
import {CustomTranslateLoader} from "./app/services/custom-translate-loader/custom-translate-loader";
import {MyMissingTranslationHandler} from "./app/services/custom-translate-loader/missing-translation-handler";
import {routes} from "./app/app.routes";
import {provideIonicAngular} from "@ionic/angular";
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";
import packageJson from '../package.json';
import {environment} from "./environments/environment";
import {ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection} from "@angular/core";
import {authInterceptor} from "./app/interceptors/auth/auth-interceptor";
import {errorsInterceptor} from "./app/interceptors/errors/errors-interceptor";
import {IonicStorageModule} from "@ionic/storage-angular";
import { Drivers } from '@ionic/storage';
import {refreshTokenInterceptor} from "./app/interceptors/refresh-token/refresh-token-interceptor";
import {firstValueFrom} from "rxjs";
import {provideEchartsCore} from 'ngx-echarts';
import {echarts} from './app/helpers/chart/echarts';
import {EM_CHART_THEME} from './app/helpers/chart/em-chart.theme';
import {PagePreferencesService} from './app/services/page-preferences/page-preferences.service';

Sentry.init({
    dsn: "https://5f69f2f9a3cabe056c098c206802c5ed@o877795.ingest.us.sentry.io/4511613919035392",
    release: `energy-master-frontend@${packageJson.version}`,
    // Set your dist version, such as "1"
    dist: "1",
    tracesSampleRate: 0.05,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    tracePropagationTargets: ["localhost"],
    enabled: environment.name !== 'dev' && environment.name !== 'local',
    environment: environment.name,
    ignoreErrors: []
  },
  SentryAngular.init
);
bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      provideIonicAngular({
        mode: "md",
        innerHTMLTemplatesEnabled: true
      }),
      {
        provide: ErrorHandler,
        useValue: SentryAngular.createErrorHandler(),
      },
      provideRouter(routes, withPreloading(PreloadAllModules)),
      provideHttpClient(withXhr(), 
        withInterceptors([authInterceptor, refreshTokenInterceptor, errorsInterceptor])
      ),
      provideTranslateService({
        loader: provideTranslateLoader(CustomTranslateLoader),
        fallbackLang: 'de',
        lang: 'de',
        missingTranslationHandler: provideMissingTranslationHandler(MyMissingTranslationHandler),
      }),
      provideAppInitializer(() => firstValueFrom(inject(TranslateService).use('de'))),
      provideAppInitializer(() => inject(PagePreferencesService).initialize()),
      provideEchartsCore({echarts, theme: EM_CHART_THEME}),
      importProvidersFrom(IonicStorageModule.forRoot({
        name: "energyMasterdb",
        driverOrder: [Drivers.IndexedDB]
      })),
    ]
})
  .catch(err => console.log(err));
